import { createFileRoute, useNavigate } from "@tanstack/react-router";
import {
  ConfigurationProfilesPage,
  type ConfigurationTab,
} from "@charphq/ui/components/pages/ConfigurationProfilesPage";

const CONFIGURATION_TABS: ConfigurationTab[] = ["profiles", "base-sets", "assignments", "fidelity"];

export const Route = createFileRoute("/configuration")({
  component: function ConfigurationRoute() {
    const search = Route.useSearch();
    const navigate = useNavigate();
    return (
      <ConfigurationProfilesPage
        searchParams={search}
        onTabChange={(tab) =>
          navigate({ to: "/configuration", search: { ...search, tab }, replace: true })
        }
      />
    );
  },
  validateSearch: (search: Record<string, unknown>) => ({
    page: Number(search.page) || 1,
    pageSize: Number(search.pageSize) || 20,
    globalFilter: (search.globalFilter as string) || undefined,
    // Default tab stays out of the URL; anything unrecognized falls back to it too.
    tab: CONFIGURATION_TABS.includes(search.tab as ConfigurationTab)
      ? (search.tab as ConfigurationTab)
      : undefined,
  }),
});
